import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import {ChartOptions, ChartDataSets} from 'chart.js';

@Component({
  selector: 'kt-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css']
})
export class BarChartComponent implements OnInit {

  @Input() chartObj: any = { labels: [], data: [], total: '', reportLabel: '', options: {} };
  @Input() indexAxis: 'x' | 'y' = 'x';
  @Input() legendVisible: boolean = false;
  @Input() isStepSizeOne: boolean = false;  


  barChartOptions: ChartOptions = {
    layout: { padding: { left: 1, right: 1, top: 1, bottom: 1 } },
    legend: { 
      position: 'bottom', // Legend at the bottom center
      labels: { 
        fontSize: 14 , // Adjust font size if needed
        padding: 20, // Spacing between legend items
      }
    },
    scales: {
      xAxes: [{ 
        ticks: { autoSkip: true, maxTicksLimit: 14 }
      }],
      yAxes: [{ 
        ticks: {
          beginAtZero: true,
          min: 0,
          stepSize: 1
        }
      }]
    },
  };

  barChartLabels: string[] = [];
  barChartType: 'bar' | 'horizontalBar' = 'bar'; 
  barChartData: ChartDataSets[] = [{ data: [], label: '', barThickness: 10 }];

  allLabels: string[] = [];
  allData: any[] = [];
  pageSize: number = 5; // Number of bars per page
  currentPage: number = 0; // Current page index
  totalPages: number = 0; // Total number of pages

  constructor() {}

  ngOnInit(): void {
    this.initChart();
    this.totalPages = Math.ceil((this.allLabels && this.allLabels.length ? this.allLabels.length : 0) / this.pageSize);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['chartObj']) {
      this.initChart();
    }
  }

  private initChart() {
    if (this.chartObj) {
      this.allLabels = this.chartObj.labels;
      this.allData = this.chartObj.data;
      this.totalPages = Math.ceil((this.allLabels && this.allLabels.length ? this.allLabels.length : 0) / this.pageSize); // Calculate total pages
      this.barChartType = this.indexAxis === 'y' ? 'horizontalBar' : 'bar';
      this.updateChartData();
    }
  }

  private updateChartData(): void {
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;


    // Slice the data and labels based on the current page
    this.barChartLabels = (this.allLabels && this.allLabels.slice) ? this.allLabels.slice(startIndex, endIndex) : [];
    this.barChartData = (this.allData && this.allData.map) ? this.allData.map((dataset: any) => ({
      data: (dataset && dataset.data) ? dataset.data.slice(startIndex, endIndex): [],
      label: dataset && dataset.label ? dataset.label : '',
      backgroundColor: dataset.color || '#0095ff',
      maxBarThickness: 30,
      borderRadius: 10, 
    })) : [];
  }

  onSliderChange(value: any): void {
    this.currentPage = value; // Update current page based on slider value
    this.updateChartData();
  }

  private getRandomColor(): string {
    const r = Math.floor(Math.random() * 255);
    const g = Math.floor(Math.random() * 255);
    const b = Math.floor(Math.random() * 255);
    return `rgba(${r}, ${g}, ${b}, 0.7)`;
  }

  formatTicks(value: number):string{
    return Math.round(value).toString();
  }

}
